import { METRIC, INT_SURVEY, US_SURVEY } from './conversion-constants';
import { AreaUnit } from '@trimble/types';
import { BaseConverterProps } from './base-converter-props.types';
import { UnreachableCaseError } from 'ts-essentials';

export const mapToMeters = ({
  value,
  baseUnit,
}: BaseConverterProps<number, AreaUnit>): number | null => {
  const orderOfMagnitude = 2; // Area units are squared length units
  switch (baseUnit) {
    case 'mm2':
      return value * Math.pow(METRIC.SCALE.milliToBase, orderOfMagnitude);
    case 'cm2':
      return value * Math.pow(METRIC.SCALE.centiToBase, orderOfMagnitude);
    case 'm2':
      return value;
    case 'km2':
      return value * Math.pow(METRIC.SCALE.kiloToBase, orderOfMagnitude);
    case 'in2':
      return value * INT_SURVEY.AREA.squareInchesToSquareMeters;
    case 'ft2':
      return value * INT_SURVEY.AREA.squareFeetToSquareMeters;
    case 'yd2':
      return value * INT_SURVEY.AREA.squareYardsToSquareMeters;
    case 'sIn2':
      return value * US_SURVEY.AREA.squareInchesToSquareMeters;
    case 'sFt2':
      return value * US_SURVEY.AREA.squareFeetToSquareMeters;
    case 'sYd2':
      return value * US_SURVEY.AREA.squareYardsToSquareMeters;
    default:
      throw new UnreachableCaseError(baseUnit);
  }
};
